import axios from "axios";
import API_URL from "../config/apiConfig";
export {
  buildMenuSavePayload,
  getPublicMenuPath,
  mergeEditedMenuItem,
} from "../services/menuModel";

const restaurantHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const getRestaurantMenus = () =>
  axios
    .get(`${API_URL}/api/menus`, { headers: restaurantHeaders() })
    .then(({ data }) => (Array.isArray(data.menus) ? data.menus : []));

export const getRestaurantMenu = (menuId) =>
  axios
    .get(`${API_URL}/api/menus/${menuId}`, { headers: restaurantHeaders() })
    .then(({ data }) => data.menu);

export const createRestaurantMenu = (menu) =>
  axios
    .post(`${API_URL}/api/menus/create-menu`, menu, { headers: restaurantHeaders() })
    .then(({ data }) => data);

export const updateRestaurantMenu = (menuId, menu) =>
  axios
    .put(`${API_URL}/api/menus/update-menu/${menuId}`, menu, { headers: restaurantHeaders() })
    .then(({ data }) => data);

// Uploads one item photo and resolves to the path to store on the item, so
// saving a menu never carries the photos themselves.
export const uploadMenuItemImage = (photo) => {
  const body = new FormData();
  body.append("image", photo, photo.name || "item.jpg");
  return axios
    .post(`${API_URL}/api/menus/upload-image`, body, { headers: restaurantHeaders() })
    .then(({ data }) => data.url);
};

export const deleteRestaurantMenu = (menuId) =>
  axios
    .delete(`${API_URL}/api/menus/delete-menu/${menuId}`, { headers: restaurantHeaders() })
    .then(({ data }) => data);

export const deleteRestaurantMenuItem = ({ menuId, categoryName, itemId }) =>
  axios
    .delete(`${API_URL}/api/menus/delete-item`, {
      headers: restaurantHeaders(),
      params: { menuId, categoryName, itemId },
    })
    .then(({ data }) => data);

export const activateRestaurantMenu = (menuId) =>
  axios
    .patch(`${API_URL}/api/menus/${menuId}/activate`, undefined, { headers: restaurantHeaders() })
    .then(({ data }) => data);

export const setRestaurantMenuStatus = (menuId, status) =>
  axios
    .patch(`${API_URL}/api/menus/${menuId}/status`, { status }, { headers: restaurantHeaders() })
    .then(({ data }) => data);
